module.exports = __webpack_public_path__ + "static/media/edit-pencil-editor.7ef299b5.svg";